const locale = {
	configuratorTitle: 'Varialis Konfigurator',
	popular: 'Najpopularnije',
	searchResults: 'Rezultati pretraživanja',
	price: 'Cijena',
	amount: 'Vrijednost',
	model: 'Model',
	name: 'Naziv',
	url: 'Url',
	company: 'Tvrtka',
	save: 'Spremi',
	filterTypeName: 'Tip',
	filterGroupName: 'Stil',
	filtersClear: 'Očisti filtre',
	filters: 'Filtri',
	searchPlaceholder: 'Pretraži...',
	configurationStep1: 'Odabir modela',
	configurationStep2: 'Konfiguracija modela',
	configurationStep3: 'Pregled konfiguracije',
	configurationStepCustomerView: 'Pregled dokumenata',
	select: 'Odaberi',
	quantity: 'Količina',
	overview: 'Pregled',
	version: 'Verzija',
	modelAndConfig: 'Model / ID konfiguracije',
	status: 'Status',
	noResults: 'Nema rezultata',
	noData: 'Nema podataka',
	next: 'Dalje',
	prev: 'Natrag',
	nextPage: 'Sljedeća stranica',
	sendInquiry: 'Pošalji upit',
	step: 'Korak',
	of: 'od',
	comment: 'Komentar',
	documentComment: 'Komentar dokumenta',
	documentCommentRemove: 'Ukloni komentar dokumenta',
	clearConfiguration: 'Poništi konfiguraciju',
	cancel: 'Odustani',
	continue: 'Nastavi',
	close: 'Zatvori',
	exception: 'Iznimka',
	generalException: 'Ups! Nešto je pošlo po zlu.',
	apiException: 'Neispravan odgovor sa servera',
	myProjects: 'Moji projekti',
	allProjects: 'Svi projekti',
	assignDocument: 'Dodijeli (interno)',
	assignDocumentWithinCompany: 'Dodijeli unutar tvrtke',
	assignDocumentOutsideCompany: 'Dodijeli izvan tvrtke',
	assignDocumentToContactTitle: 'Kontakt',
	assignDocumentToContactAddNew: 'Dodaj novi kontakt',
	assignDocumentToContactConfirmation: 'Jeste li sigurni da želite promijeniti kontakt?',
	sendDocument: 'Pošalji partneru',
	toggleProjectStatus: 'Projekt',
	unknownUser: 'Nepoznat korisnik',
	saveConfiguration: 'Dodaj u košaricu',
	saveConfigurationToDocument: 'Spremi u dokument',
	addConfigurationToDocument: 'Dodaj u dokument',
	customerNewOffer: 'Kreiraj dokument',
	customerProcess: 'Obradi',
	customerSendERP: 'Izvoz u ERP',
	customerImportEdi: 'Uvoz iz ERP-a',
	customerNewVersion: 'Postavi zadanu vrijednost',
	customerAssign: 'Dodijeli osobi',
	customerConfirmOrder: 'Potvrdi narudžbu',
	customerConfirmOrderMessage:
		'Ovom potvrdom narudžba (br. dokumenta {number}) se pušta u proizvodnju. Potvrdom prihvaćam povezane financijske obveze (obveza plaćanja).',
	customerConfirmInqury: 'Potvrdi upit',
	customerConfirmInquryNewProject: 'Kreiraj u novom projektu',
	customerSendToConfirm: 'Pošalji na potvrdu',
	customerSend: 'Pošalji',
	customerForward: 'Proslijedi',
	customerSendToSupplier: 'Pošalji dobavljaču',
	customerSendOffer: 'Pošalji dokument',
	customerSendOfferMissingEmail: 'Dokumenta ni mogoče poslati. E-naslov manjka.',
	customerSendDocument: 'Pošalji dokument',
	customerDelete: 'Obriši',
	customerDeleteConfirm: 'Jeste li sigurni da želite obrisati odabrani zapis?',
	configurator: 'Konfigurator',
	configuratorPublic: 'Dokumentacija proizvoda',
	open: 'Otvori',
	customerEditingTitleInquiry: 'Uređivanje upita',
	customerEditingTitleOffer: 'Uređivanje ponude',
	documentEditing: 'Uređivanje dokumenta',
	configurationEditing: 'Uređivanje konfiguracije',
	adminCalculationDiscounts: 'Popusti',
	adminCalculationAddDiscount: 'Dodaj popust',
	adminCalculationAdditional: 'Dodaci',
	adminCalculationCostsNet: 'Usluge',
	adminCalculationAdditionalCosts: 'Trošak dodataka',
	adminCalculationAddAdditionalCost: 'Dodaj dodatak',
	adminCalculationAddNetCost: 'Dodaj uslugu',
	adminCalculationConfigurationPrice: 'Cijena konfiguracije',
	adminCalculationAdditionalSum: 'Ukupni trošak dodataka',
	adminCalculationConfigurationWithAdditionalSum: 'Cijena konfiguracije s dodacima',
	adminCalculationDiscountPercentageSum: 'Ukupni postotak popusta',
	adminCalculationDiscountSum: 'Ukupna vrijednost popusta',
	adminCalculationConfigurationWithDiscountSum: 'Cijena konfiguracije s dodacima i popustima',
	adminCalculationServiceSum: 'Ukupni trošak usluga',
	adminCalculationSum: 'Vrijednost',
	adminRemark: 'Napomena',
	adminRemarkAttachment: 'Odabrani privitak:',
	adminRemarkAddAttachment: 'Dodaj privitak',
	adminRemarkAddAttachmentError: 'Ovaj format privitka nije dopušten.',
	adminDocumentationAdd: 'Učitaj privitak',
	adminDocumentationAddUrl: 'Dodaj poveznicu',
	adminDocumentCustomer: 'Kupac',
	adminDocumentContact: 'Kontakt',
	adminDocumentPartner: 'Odgovorni partner',
	adminDocumentPartnerRecipient: 'Partner',
	adminDocumentDateModified: 'Datum zadnje izmjene',
	adminDocumentStatus: 'Status',
	adminDocumentDocumentNumber: 'Broj dokumenta',
	adminDocumentProject: 'Projekt',
	adminDocumentProjectStatus: 'Status projekta',
	adminDocumentDocumentOrder: 'Broj narudžbe dokumenta',
	adminDocumentBuyerOrderNumber: 'Broj narudžbe kupca',
	adminDocumentComission: 'Provizija',
	adminDocumentCustomerNumber: 'Broj kupca',
	adminDocumentCustomerPosition: 'Pozicija kupca',
	adminDocumentCustomerSubPosition: 'Podpozicija kupca',
	adminDocumentCommission: 'Provizija',
	adminDocumentDeliveryTime: 'Vrijeme isporuke',
	adminMenuDocument: 'Podaci o dokumentu',
	adminMenuConfigurations: 'Konfiguracije',
	adminMenuHistory: 'Povijest',
	adminMenuConfiguration: 'Konfiguracija',
	adminMenuCalculation: 'Pregled konfiguracije',
	adminMenuImages: 'Slike',
	adminMenuSalesRemarks: 'Prodajne napomene',
	adminMenuInstallerRemarks: 'Napomene instalatera',
	adminMenuPosition: 'Podaci o poziciji',
	adminMenuDiscountsCosts: 'Popusti, Usluge, PDV',
	adminMenuTechnicalDocumentation: 'Tehnička dokumentacija',
	adminMenuPrintDocument: 'Ispis i slanje',
	insideView: 'Unutarnji prikaz',
	facade: 'Fasada',
	cartSuccess: 'Klikom na ikonu košarice možete urediti njezin sadržaj.',
	saving: 'Spremanje',
	contactTitle: 'Podaci o kontaktu i dogovorima',
	contactTitleSales: 'Podaci o kontaktu',
	inquirySalesDialog: 'Dokument',
	cart: 'Košarica',
	cartSendInquiry: 'Pošalji upit',
	cartRemove: 'Ukloni',
	cartInquirySentText: ', hvala na vašem upitu. Obradit ćemo ga što je prije moguće.',
	cartInquirySentText2: 'Hvala na vašem upitu. Obradit ćemo ga što je prije moguće.',
	cartInquirySentText3: 'Dokument je kreiran',
	cartInquirySent: 'Upit uspješno poslan',
	cartOverride: 'Želite li prebrisati postojeću konfiguraciju ili stvoriti novu?',
	cartSaving: 'Spremanje konfiguracije',
	cartSavingSuccess: 'Vaša konfiguracija je dodana u košaricu',
	documentSaving: 'Spremanje dokumenta',
	successfullySaved: 'Uspješno spremljeno',
	cartButtonOverride: 'Prebriši postojeću konfiguraciju',
	cartButtonNew: 'Stvori novu konfiguraciju',
	cartRemoveTitle: 'Uklanjanje konfiguracije',
	cartRemovalText: 'Konfiguracija uspješno uklonjena',
	addDiscount: 'Popust',
	addCost: 'Trošak',
	addNetCost: 'Usluga',
	discountText: 'Naziv',
	discountValue: 'Postotak (%)',
	discountLevel: 'Razina',
	discountType: 'Vrsta popusta',
	discount: 'Postotak',
	sortOrder: 'Redoslijed',
	discountAmount: 'Iznos popusta',
	discountValueAfter: 'Vrijednost nakon popusta',
	costText: 'Naziv',
	costValue: 'Vrijednost',
	requestDocumentation: 'Zatraži dokumentaciju',
	requestSpecialDocumentation: 'Zatraži posebnu dokumentaciju',
	loadSpecialDocumentation: 'Učitaj posebnu dokumentaciju',
	user: 'Korisnik',
	image: 'Slika',
	date: 'Datum',
	customer: 'Kupac',
	partner: 'Partner',
	commission: 'Provizija',
	responsiblePerson: 'Odgovorna osoba',
	position: 'Pozicija',
	value: 'Vrijednost',
	dataLastChange: 'Datum zadnje promjene',
	documentation: 'Dokumentacija',
	inquiries: 'Upiti',
	offers: 'Ponude',
	printOffer: 'Ispis dokumenta',
	printDownload: 'Preuzmi',
	printChangeToSend: 'Promijeni u Poslano',
	printEditSent: 'Kreiraj email',
	printEmailSubject: 'Varialis - {number}',
	printEmailBody:
		'Poštovani,\n\nNa temelju vašeg upita u privitku šaljemo odgovarajuću ponudu br. {number}.\n\nSrdačan pozdrav,\nVARIALIS portal\n\n\n\nNapomena: E-mail može sadržavati povjerljive informacije namijenjene isključivo primatelju. Ako je poruka greškom poslana drugdje, obavijestite pošiljatelja. Ako poruka nije bila namijenjena vama, informacije se ne smiju koristiti, dijeliti, kopirati, ispisivati niti na bilo koji način iskorištavati.',
	email: 'Email',
	password: 'Lozinka',
	signIn: 'Prijava',
	signUp: 'Registracija',
	profile: 'Profil',
	signingOut: 'Odjava',
	salesman: 'Prodavač',
	salesmanResponsible: 'Odgovorni prodavač',
	signOut: 'Odjava',
	submit: 'Pošalji',
	loginSuccess: '',
	loginError: 'Došlo je do problema pri prijavi.',
	addressing: 'Titula',
	firstName: 'Ime',
	firstAndLastName: 'Ime i prezime',
	lastName: 'Prezime',
	loginFailed: 'Prijava nije uspjela',
	loginNoPass: 'Unesite svoju lozinku',
	loginNoUsername: 'Unesite svoju email adresu',
	forgotPassword: 'Zaboravljena lozinka?',
	resetPassword: 'Resetiraj lozinku',
	resetPasswordMessage: 'Email za potvrdu je poslan, provjerite svoju pristiglu poštu za nastavak.',
	registrationFailed: 'Registracija nije uspjela',
	missingFields: 'Unesite sva obavezna polja.',
	registrationSucceeded: 'Hvala na registraciji. Primili ste email s poveznicom za dovršetak procesa.',
	profileUpdateSucceeded: 'Podaci vašeg profila su ažurirani.',
	profileOtherTitle: 'Vnesi ostale kontaktne podatke',
	profileDeliveryTitle: 'Adresa za dostavu',
	profileReceiptTitle: 'Adresa za račun',
	profileAddressAdd: 'Dodaj adresu',
	profileAddressEdit: 'Uredi adresu',
	differentThenCompanyAddress: 'Unesite podatke o tvrtki',
	differentThenContactAddress: 'Drugačija od kontakt adrese',
	activationSucceeded: 'Aktivacija uspješna',
	accountActivation: 'Aktivacija računa',
	confirmPassword: 'Potvrdi lozinku',
	activate: 'Aktiviraj',
	missingToken: 'Nevažeća aktivacija. Molimo registrirajte se ponovno.',
	telephone: 'Telefon',
	inquiryPartner: 'Partner',
	vat: 'OIB / PDV broj',
	registrationNumber: 'Matični broj',
	inquiryTitle:
		'Hvala na vašem upitu. Za obradu molimo ispunite kontakt podatke, označite (neobavezne) privole i pošaljite upit klikom na gumb Pošalji.<br/>Ovim dajete privolu da vas naša tvrtka i prodajni partneri kontaktiraju putem e-maila i/ili telefona koristeći dane podatke kako bi ispunili vaš zahtjev, dali ponudu ili savjetovali o proizvodima. U slučaju narudžbe, dopuštate prijenos vaših podataka ovlaštenom osoblju za savjetovanje i izmjeru na licu mjesta radi realizacije narudžbe.',
	inquiryTitleCustomer: 'Unesite podatke o kupcu',
	inquiryTitleExistingCustomer: 'Odaberite postojeći kontakt',
	inquiryDocumentType: 'Vrsta dokumenta',
	address: 'Ulica i kućni broj (Adresa)',
	city: 'Grad',
	zip: 'Poštanski broj',
	post: 'Poštanski broj',
	country: 'Država',
	selectCountry: 'Odaberite državu',
	selectDiscountType: 'Odaberite vrstu popusta',
	selectInquiryPartner: 'Odaberite partnera',
	companyName: 'Naziv tvrtke',
	companyRegistration: 'Matični broj tvrtke',
	companyVAT: 'PDV broj tvrtke',
	inquiryLegalAdd: 'Dodatno za pravne osobe',
	inquiryConsents: 'Privole',
	inquiryConsent1Title: 'Ponude i podsjetnici',
	inquiryConsent1: 'npr. obavijesti o relevantnim ponudama proizvoda, rezervnih dijelova, dodataka i drugih usluga.',
	inquiryConsent2Title: 'Obavijesti',
	inquiryConsent2:
		'najave i pozivi na događanja povodom lansiranja novih modela i kataloga, sajmova, dana otvorenih vrata, prezentacija i drugih događanja.',
	inquiryConsent3Title: 'Ankete',
	inquiryConsent3: 'istraživanja za dobivanje vašeg mišljenja radi poboljšanja naših proizvoda i usluga.',
	equalPasswords: 'Unesite iste lozinke',
	type: 'Tip',
	brands: 'Robne marke',
	partners: 'Partneri',
	delete: 'Obriši',
	languages: 'Jezici',
	clearCache: 'Očisti predmemoriju',
	tags: 'Pronađi oznaku',
	text: 'Tekst',
	desc: 'Opis',
	configuration: 'Konfiguracija',
	document: 'Dokument',
	edit: 'Uredi',
	change: 'Promijeni',
	view: 'Pregledaj',
	clone: 'Stavka',
	copy: 'Kopiraj',
	remove: 'Ukloni',
	default: 'Zadano',
	add: 'Dodaj',
	deleting: 'Brisanje...',
	adding: 'Dodavanje...',
	cloning: 'Kloniranje...',
	print: 'Ispis',
	submitForProduction: 'Pošalji u proizvodnju',
	cartAddingDisabled:
		'Dosegli ste ograničenje spremljenih projekata. Prijavite se za neograničen broj projekata.\nZa registraciju ili prijavu kliknite na ikonu u gornjem desnom kutu.',
	notSucceeded: 'neuspješno',
	documentType: 'Vrsta dokumenta',
	printPrice: 'Cijene',
	printColorImage: 'Slika u boji',
	printTechImage: 'Tehnički crtež',
	printConditions: 'Uvjeti plaćanja i isporuke',
	selectPrintTemplate: 'Odaberite predložak',
	selectPrintLanguage: 'Odaberite jezik',
	sendToConfirmation: 'Pošalji na potvrdu',
	inConfirmation: 'Na potvrdi',
	isFinished: 'Završeno',
	confirm: 'Potvrdi',
	reject: 'Odbij',
	reset: 'Poništi',
	downloadPriceFile: 'Preuzmi xlsx',
	termsPayment: 'Uvjeti plaćanja',
	termsSales: 'Uvjeti prodaje',
	addTermPayment: 'Dodaj uvjet plaćanja',
	addTermSales: 'Dodaj uvjet isporuke',
	editTermPayment: 'Uredi uvjet plaćanja',
	editTermSales: 'Uredi uvjet isporuke',
	viewTermPayment: 'Pregled uvjeta plaćanja',
	viewTermSales: 'Pregled uvjeta isporuke',
	term: 'Uvjet',
	termsPage: 'Uvjeti plaćanja i isporuke',
	send: 'Pošalji',
	confirmDelete: 'Jeste li sigurni da želite obrisati odabrani zapis?',
	confirmArchive: 'Jeste li sigurni da želite arhivirati odabrani zapis?',
	confirmReset: 'Jeste li sigurni da želite poništiti odabranu konfiguraciju na zadane postavke?',
	confirmClone: 'Jeste li sigurni da želite klonirati odabrani zapis?',
	confirmCopy: 'Jeste li sigurni da želite kopirati odabrani zapis?',
	confirmChangeStatusToSend: 'Jeste li sigurni da želite promijeniti status dokumenta u Poslano?',
	confirmChangeStatusSpecialTechnical:
		'Pažnja! Ponovnim zahtjevom za tehničku dokumentaciju pripremljena posebna tehnička dokumentacija bit će izgubljena.',
	confirmRequestDocumentation: 'Pažnja! Ponovnim zahtjevom za tehničku dokumentaciju pripremljena posebna tehnička dokumentacija bit će izgubljena.',
	confirmSend: 'Jeste li sigurni da želite poslati dokument?',
	confirmSendDocument:
		'Primatelj dokumenta je:<br/>- Partner: {Partner}<br/>- Prodavač: {Salesman}<br/>- Kontakt: {Contact}<br/><br/> Jeste li sigurni da želite poslati dokument?',
	changeRecipient: 'Promijeni primatelja',
	totalPriceWithoutTax: 'Ukupna cijena bez PDV-a',
	totalTax: 'Ukupni PDV',
	finalPrice: 'Ukupna cijena s PDV-om',
	selectTax: 'Odaberite oporezivanje',
	tax: 'PDV',
	printTemplateSelect: 'Dokument treba sadržavati:',
	userUploaded: 'Korisnik je učitao',
	yes: 'Da',
	no: 'Ne',
	contact: 'Kontakt',
	autoSaveConfiguration: 'Promjene se automatski spremaju',
	loginToViewPrices: 'Prijavite se za prikaz cijena',
	cookieLaw:
		'Web stranica koristi kolačiće za osiguranje potpune funkcionalnosti. Kolačići pohranjuju vaše korištenje stranice. Korištenjem stranice prihvaćate upotrebu kolačića. Više informacija:',
	cookiesTitle: 'Informacije o korištenju kolačića',
	details: 'Detalji',
	sourceDocument: 'Izvorni dokument',
	download: 'Preuzmi',
	downloadPDF: 'Preuzmi PDF',
	clonePart: 'Stavka',
	languageChange: 'Promjena jezika',
	languageChangeConfirm: 'Promjenom jezika bit ćete preusmjereni na početni ekran. Nespremljene promjene konfiguracije bit će zanemarene.',
	brandChange: 'Promjena robne marke',
	brandChangeConfirm: 'Promjenom robne marke bit ćete preusmjereni na početni ekran. Nespremljene promjene konfiguracije bit će zanemarene.',
	specialOffer: 'Posebna ponuda',
	archive: 'Arhiva',
	includeArchived: 'Prikaži arhivirane dokumente',
	showAll: 'Prikaži sve',
	cartEmpty: 'Košarica je prazna',
	clipboard: 'Kopirano u međuspremnik',
	inputText: 'Unesite tekst',
	inputNumber: 'Unesite broj',
	twoDecimalPlaces: 'dvije decimale',
	treeDetails: 'Popis parametara',
	deliveryTime: 'Isporuka',
	viewChangeTitle: 'Promjena prikaza',
	viewChangeDescription: 'Nakon potvrde bit ćete preusmjereni na željeni prikaz. Nespremljene promjene konfiguracije bit će zanemarene. ',
};
export default locale;
